import { FIND_EDOK_FORM_REQUEST, findEdokFormFailure, findEdokFormSuccess} from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from, EMPTY } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

export function findEdokFormEpic(action$, store$, { EdokRepository }) {
    return action$.pipe(
        ofType(FIND_EDOK_FORM_REQUEST),
        mergeMap( action =>{
            const { id } = action.payload;

            if(!id.trim()) {
                return EMPTY;
            }

            return from(
                EdokRepository.findById( id )
                    .then(form => findEdokFormSuccess(form))
                    .catch(error => findEdokFormFailure(error)),
            );
        }),
    );
}
